"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAcceptNotificationErrorResponse = exports.Name = exports.AcceptNotificationFailedEvent = void 0;
var _failedEventData = require("@ori-events/failed-event-data");
const Name = exports.Name = 'accept-notification-failed';
const AcceptNotificationFailedEvent = exports.AcceptNotificationFailedEvent = Name;
const isAcceptNotificationErrorResponse = response => (0, _failedEventData.isErrorResponse)(response);
exports.isAcceptNotificationErrorResponse = isAcceptNotificationErrorResponse;
